import React, { useState } from 'react';
import AuthForm from './AuthForm';
import FileForm from './FileForm';
import Success from './Success';

const Card = () => {
  const [authenticated, setAuthenticated] = useState(false);

  const [token, setToken] = useState(null);

  const [success, setSuccess] = useState(false);

  return (
    <div className="card">
      <div className="card-body mt-3">
        {!authenticated && !success && (
          <AuthForm
            setAuthenticated={setAuthenticated}
            setToken={setToken}
          />
        )} 

        {authenticated && !success && (
          <FileForm
            token={token}
            setSuccess={setSuccess}
          />
        )}

        {success && (
          <Success
            setSuccess={setSuccess}
            setToken={setToken}
            setAuthenticated={setAuthenticated}
          />
        )}
      </div>
    </div>
  );
}

export default Card;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/Card.js